import ng from 'angular';
import * as Types from '@/types';
import { ShortLangType } from '@/configuration';

export class MoleculeFormAppSelectorController implements ng.IController {

    public apps: Types.AppInstaller.AppSpecification[];
    public isOsInstall = false;
    public selectedAppName: string | number;
    public dropdownItems: any[];
    public appItems: any[];
    public language: ShortLangType;
    public callbackOnAppChange: (selection: any) => any;
    public popoverPosition: string;

    public $onInit() {
        this.dropdownItems = [];
        this.appItems = [];

        for (const app of this.apps) {
            this.dropdownItems.push({
                name: `${app.data.provides.info.name} (${app.data.provides.info.version})`,
                value: app.general.pkgName
            });

            this.appItems[app.general.pkgName] = app;
        }
    }

    public get appSelected() {
        return this.selectedAppName !== undefined && this.selectedAppName !== null;
    }

    public get selectedApp() {
        return this.appItems[this.selectedAppName];
    }

    public set selectedApp(value: any) {
        if (value !== undefined && value !== null) {
            this.selectedAppName = value.general.pkgName;
        }
    }

    public get appDescription() {
        if (this.language === undefined) {
            return '';
        }
        return this.selectedApp.data.provides.info.translations[this.language];
    }
}


export class MoleculeFormAppSelectorComponent implements ng.IComponentOptions {
    public bindings = {
        apps: '<',
        callbackOnAppChange: '<',
        isOsInstall: '<',
        language: '<',
        popoverPosition: '@',
        selectedApp: '='
    };
    public controller =  MoleculeFormAppSelectorController;
    public template = require('./app-selector.html');
}
